<template>
  <div>
    <div class="d-flex justify-space-between">
      <div class="d-flex w-100">
        <div class="mr-1 w-20">
          <AppSearchInput
            v-if="card"
            v-model="paramsMaterial.search"
            :label="$t('search') + ':'"
            :placeholder="$t('search') + '...'"
            @callback="refresh()"
          />
          <AppSearchInput
            v-if="!card"
            v-model="paramsInstruments.search2"
            :label="$t('search') + ':'"
            :placeholder="$t('search') + '...'"
            @callback="refresh()"
          />
        </div>

        <div class="mx-1 w-20">
          <b-form-group :label="$t('filter_by_destination_warehouse') + ':'">
            <v-select
              v-if="card"
              class="bg-white rounded"
              v-model="paramsMaterial.storage"
              label="title"
              :options="GET_APPLICATION_TYPE"
              :reduce="(p) => p.id"
              @input="onFiltered"
            />
            <v-select
              v-if="!card"
              class="bg-white rounded"
              v-model="paramsInstruments.storage2"
              label="title"
              :options="GET_APPLICATION_TYPE"
              :reduce="(p) => p.id"
              @input="onFiltered"
            />
          </b-form-group>
        </div>

        <div class="mx-1 w-20">
          <b-form-group :label="$t('dateFromTo') + ':'">
            <VueDataPicker
              v-if="card"
              v-model="dateFilter"
              :other-props="{ 'is-range': true }"
              @input="datePicker"
            />
            <VueDataPicker
              v-if="!card"
              v-model="dateFilter2"
              :other-props="{ 'is-range': true }"
              @input="datePicker"
            />
          </b-form-group>
        </div>

        <!-- <div class="mx-1 w-20">
          <b-form-group label="Фильт по автору">
            <v-select
              v-model="filter.author"
              class="bg-white rounded"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :get-option-label="el => { return el.first_name + ' ' + el.last_name}"
              :options="GET_APPLICATION_AUTHOR.results"
              :reduce="(p) => p.id"
              @input="onFiltered"
              @search="onAuthorSearch"
            />
          </b-form-group>
        </div> -->
      </div>
      <div class="d-flex align-items-center ml-1" style="margin-top: 10px">
        <b-form-radio-group
          id="radio-dark"
          v-model="card"
          class="list item-view-radio-group"
          buttons
          button-variant="outline-primary"
        >
          <b-form-radio

            v-for="option in itemViewOptions"
            :key="option.value"
            :value="option.value"
          >
            {{ option.text }}
          </b-form-radio>
        </b-form-radio-group>
      </div>
    </div>

    <div v-if="!isLoading">
      <!-- <b-card> -->
      <b-table
        v-if="card"
        id="user-table"
        class="px-1 rounded mt-1 bg-light-secondary dark"
        :fields="fields"
        :items="applicationMaterial.results"
        show-empty
        :tbody-tr-class="['tableRowClass']"
        small
        responsive
        :empty-text="$t('empty_text')"
      >
        <template #head()="props">
          <span>{{ $t(props.label) }}</span>
        </template>

        <template #cell(product)="{ item }">
          <b-badge v-for="(i, index) in item.goods" :key="index" class="mr-50">
            <span v-if="i.good && i.good.product && i.good.product.title">
              {{ i.good.product.title }}
            </span>
          </b-badge>
        </template>

        <template #cell(good)="{ item }">
          <b-badge v-for="(i, index) in item.goods" :key="index" class="mr-50">
            <span v-if="i.good && i.good.value">
              {{ i.good.value }} - {{ $_formatPriceMixin(i.count) }}
            </span>
          </b-badge>
        </template>

        <template #cell(requirement_type)="{ value }">
          <b-badge v-if="value" variant="success">
            {{ value }}
          </b-badge>
        </template>

        <template #cell(status)="props">
          <div class="d-flex">
            <b-badge :variant="props.item.status.color">
              <span>{{ props.item.status.name }}</span>
            </b-badge>
            <feather-icon
              v-b-tooltip.focus="{ variant: props.item.status.color }"
              :title="props.item.status.description"
              class="ml-25"
              icon="InfoIcon"
              size="24"
            />
          </div>
        </template>

        <template #cell(actions)="props">
          <div class="d-flex align-items-center justify-content-center">
            <b-button
              v-b-tooltip.hover.v-primary
              :title="$t('watch')"
              size="sm"
              class="mt-50 mb-50"
              variant="primary"
              @click="$router.push(`/applications/material/view/${props.item.id}`)"
            >
              <feather-icon icon="EyeIcon" size="15" />
            </b-button>
          </div>
        </template>
      </b-table>

      <b-table
        v-if="!card"
        id="user-table"
        class="px-1 rounded mt-1 dark bg-light-secondary"
        :fields="fields"
        :items="applicationInstrument.results"
        show-empty
        :tbody-tr-class="['tableRowClass']"
        small
        responsive
        :empty-text="$t('empty_text')"
      >
        <template #head()="props">
          <span>{{ $t(props.label) }}</span>
        </template>

        <template #cell(product)="{ item }">
          <b-badge v-for="(i, index) in item.instruments" :key="index" class="mr-50">
            <span v-if="i.instrument && i.instrument.type && i.instrument.type.title">
              {{ i.instrument.type.title }}
            </span>
          </b-badge>
        </template>

        <template #cell(good)="{ item }">
          <b-badge v-for="(i, index) in item.instruments" :key="index" class="mr-50">
            <span v-if="i.instrument && i.instrument.title && i.count">
              {{ i.instrument.title }} - {{ $_formatPriceMixin(i.count) }}
            </span>
          </b-badge>
        </template>

        <template #cell(requirement_type)="{ value }">
          <b-badge v-if="value" variant="success">
            {{ value }}
          </b-badge>
        </template>

        <template #cell(status)="props">
          <div class="d-flex">
            <b-badge :variant="props.item.status.color">
              <span>{{ props.item.status.name }}</span>
            </b-badge>
            <feather-icon
              v-b-tooltip.focus="{ variant: props.item.status.color }"
              :title="props.item.status.description"
              class="ml-25"
              icon="InfoIcon"
              size="24"
            />
          </div>
        </template>

        <template #cell(actions)="props">
          <div class="d-flex align-items-center justify-content-center">
            <b-button
              v-b-tooltip.hover.v-primary
              :title="$t('watch')"
              size="sm"
              class="mt-50 mb-50"
              variant="primary"
              @click="$router.push(`/applications/instrument/view/${props.item.id}`)"
            >
              <feather-icon icon="EyeIcon" size="15" />
            </b-button>
          </div>
        </template>
      </b-table>
      <!-- </b-card> -->
    </div>

    <b-card v-else>
      <Loader />
    </b-card>

    <Pagination
      v-if="card"
      :rows="applicationMaterial.count"
      :params="paramsMaterial"
      class="w-100"
      @refresh="refresh()"
      :page="paramsMaterial.page"
      :page_size="paramsMaterial.page_size"
    />

    <Pagination
      v-if="!card"
      :rows="applicationInstrument.count"
      :params="paramsInstruments"
      class="w-100"
      @refresh="refresh()"
      :page="paramsInstruments.page"
      :page_size="paramsInstruments.page_size"
    />
      <!-- :page="filter.page"
      :page_size="filter.page_size" -->
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BButton,
  BTable,
  VBTooltip,
  BBadge,
  BCard,
  BFormRadio,
  BFormRadioGroup,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { mapActions, mapGetters, mapState } from "vuex";
import AppSearchInput from "@/components/AppSearchInput.vue";
import VueDataPicker from "@/components/VueDatePicker.vue";
import Pagination from "@/components/Pagination.vue";
import areYouSure from "@/mixins/areYouSure";
import priceFormatMixin from "@/mixins/priceFormatMixin";
import loader from "@/mixins/loader";
import Loader from "@/components/Loader.vue";
import addQueryToCurrentPage from "@/mixins/addQueryToCurrentPage";

export default {
  components: {
    AppSearchInput,
    VueDataPicker,
    Pagination,
    vSelect,
    Loader,
    BRow,
    BCol,
    BCard,
    BFormGroup,
    BButton,
    BTable,
    BBadge,
    BFormRadio,
    BFormRadioGroup,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  mixins: [areYouSure, priceFormatMixin, loader, addQueryToCurrentPage],
  data() {
    return {
      isLoading: false,


      
      // ===============  PRIMARY_DATA_SECTION START ===============
      paramsMaterial: {
        search: "",
        storage: "",

        page_size: 10,
        page: 1,
        purchase: true,
      },
      paramsInstruments: {
        search2: "",
        storage2: "",

        page_size: 10,
        page: 1,
        purchase: true,
      },
      dateFilter: {
        start_date: "",
        end_date: "",
      },
      dateFilter2: {
        start_date2: "",
        end_date2: "",
      },
      card: true,
      itemViewOptions: [
        {
          text: this.$t("reference.material"),
          value: true,
        },
        {
          text: this.$t("reference.instrument"),
          value: false,
        },
      ],
      fields: [
        {
          label: "№",
          key: "id",
          thClass: "tableHeadClass",
        },
        {
          label: "destination_warehouse",
          key: "storage",
          thClass: "tableHeadClass",
          tdClass: "text-center",
          formatter: (data) => {
            if (data && data.title) {
              return data.title;
            }
          },
        },
        {
          label: "courses.type",
          key: "product",
          thClass: "tableHeadClass",
        },
        {
          label: "product",
          key: "good",
          thClass: "tableHeadClass",
        },
        {
          label: "general.created_at",
          key: "created_at",
          formatter: (data) => this.$dayjs(data).format("DD.MM.YYYY"),
          thClass: "tableHeadClass",
        },
        {
          label: "status",
          key: "status",
          formatter: (data) => data?.name,
          thClass: "tableHeadClass",
        },
        {
          label: "actions",
          key: "actions",
          thClass: "tableHeadClass",
        },
      ],
      // ===============  PRIMARY_DATA_SECTION END ===============




    };
  },
  computed: {
    ...mapState("application", [
      "applicationMaterial",
      "applicationInstrument",
    ]),
    ...mapGetters("application", [
      "GET_APPLICATION_TYPE",
      "GET_APPLICATION_AUTHOR",
    ]),
  },
  watch: {},
  async mounted() {
    // await this.$_loaderStart();
    this.isLoading = true;



    
    // ===============  PRIMARY_REQUESTS_SECTION START ===============
    await this.FETCH_APPLICATION_TYPE({ is_object: 1, mini: true });
    await this.FETCH_APPLICATION_AUTHOR({ mini: true });

    await this.FETCH_APPLICATIONS_MATERIAL({ 
      page: this.$route.query.page ? this.$route.query.page : 1,
      page_size: this.$route.query.page_size ? this.$route.query.page_size : 10,

      search: this.$route.query.search ? this.$route.query.search : "",
      storage: this.$route.query.storage ? this.$route.query.storage : "",

      start_date: this.$route.query.start_date ? this.$route.query.start_date : "",
      end_date: this.$route.query.end_date ? this.$route.query.end_date : "",

      purchase: true
    });

 


    await this.FETCH_APPLICATION_INSTRUMENT({ 
      // ...this.paramsInstruments,
      page: this.$route.query.page ? this.$route.query.page : 1,
      page_size: this.$route.query.page_size ? this.$route.query.page_size : 10,

      search: this.$route.query.search2 ? this.$route.query.search2 : "",
      storage: this.$route.query.storage2 ? this.$route.query.storage2 : "",

      start_date: this.$route.query.start_date2 ? this.$route.query.start_date2 : "",
      end_date: this.$route.query.end_date2 ? this.$route.query.end_date2 : "",
     });


    let storage = this.GET_APPLICATION_TYPE.find((elem) => elem.id == this.$route.query.storage)
    if(storage){
      this.paramsMaterial.storage = {id: storage.id, title: storage.title}
    }


    let storage2 = this.GET_APPLICATION_TYPE.find((elem) => elem.id == this.$route.query.storage2)
    if(storage2){
      this.paramsInstruments.storage2 = {id: storage2.id, title: storage2.title}
    }


    this.paramsMaterial.search = this.$route.query.search ? this.$route.query.search : "";
    this.paramsInstruments.search2 = this.$route.query.search2 ? this.$route.query.search2 : "";

    this.dateFilter.start_date = this.$route.query.start_date ? this.$route.query.start_date : "";
    this.dateFilter.end_date = this.$route.query.end_date ? this.$route.query.end_date : "";

    this.dateFilter2.start_date2 = this.$route.query.start_date2 ? this.$route.query.start_date2 : "";
    this.dateFilter2.end_date2 = this.$route.query.end_date2 ? this.$route.query.end_date2 : "";

    this.paramsMaterial.page_size = this.$route.query.page_size ? this.$route.query.page_size : 10;
    this.paramsInstruments.page_size = this.$route.query.page_size ? this.$route.query.page_size : 10;


    setTimeout(() => {
      this.paramsMaterial.page = this.$route.query.page ? this.$route.query.page : 1;
      this.paramsInstruments.page = this.$route.query.page ? this.$route.query.page : 1;
    }, 0)

    // ===============  PRIMARY_REQUESTS_SECTION END ===============




    this.isLoading = false;
  },

  // async beforeRouteLeave(to, from, next) {
  //   await this.$_loaderStop();
  //   next();
  // },
  methods: {
    ...mapActions("application", [
      "FETCH_APPLICATIONS_MATERIAL",
      "FETCH_APPLICATION_INSTRUMENT",
      "FETCH_APPLICATION_TYPE",
      "FETCH_APPLICATION_AUTHOR",
    ]),




    // ===============  REFRESH_SECTION START ===============
    async refresh() {
      this.isLoading = true;

      let filter = {}

      if (this.card) {

        filter = {...this.paramsMaterial}
        if(this.paramsMaterial.storage){
          filter.storage = typeof this.paramsMaterial.storage == "number" ? this.paramsMaterial.storage : this.paramsMaterial.storage.id
        }

        await this.FETCH_APPLICATIONS_MATERIAL({
          ...this.paramsMaterial,
          ...this.dateFilter,
        });


      } else {

        filter = {...this.paramsInstruments}
        if(this.paramsInstruments.storage2){
          filter.storage = typeof this.paramsInstruments.storage2 == "number" ? this.paramsInstruments.storage2 : this.paramsInstruments.storage2.id
        }

        await this.FETCH_APPLICATION_INSTRUMENT({
          ...this.paramsInstruments,
          start_date: this.dateFilter2.start_date2,
          end_date: this.dateFilter2.end_date2,
        });

      }

      this.$_addParamsToLocation({ ...filter, ...this.dateFilter, ...this.dateFilter2 })
      
      this.isLoading = false;
    },
    // ===============  REFRESH_SECTION END ===============











    // ===============  FILTERS_SECTION START ===============
    async onFiltered() {
      this.isLoading = true;
      let filter = {}

      // this.filter.page = 1

      if (this.card) {
         filter = {...this.paramsMaterial}
        this.paramsMaterial.page = 1;

        await this.FETCH_APPLICATIONS_MATERIAL({ 
          ...this.paramsMaterial,
          ...this.dateFilter,
         });
      } else {
        filter = {...this.paramsInstruments}
        this.paramsInstruments.page = 1;

        await this.FETCH_APPLICATION_INSTRUMENT({ 
          ...this.paramsInstruments,
          start_date: this.dateFilter2.start_date2,
          end_date: this.dateFilter2.end_date2,
         });
      }

      this.$_addParamsToLocation({ ...filter, ...this.dateFilter, ...this.dateFilter2 })

      this.isLoading = false;
    },

    async datePicker(e) {
      this.isLoading = true;
      let filter = {}

      // this.paramsMaterial = this.removeUnusedParams(this.paramsMaterial);
      // this.paramsInstruments = this.removeUnusedParams(this.paramsInstruments);

      this.paramsMaterial.page = 1;
      this.paramsInstruments.page = 1;

      if (e) {
        
        if (this.card) {

          this.dateFilter.start_date = e.start;
          this.dateFilter.end_date = e.end;
          filter = {...this.paramsMaterial}

          await this.FETCH_APPLICATIONS_MATERIAL({
            ...this.paramsMaterial,
            start_date: this.dateFilter.start_date,
            end_date: this.dateFilter.end_date,
          });

        } else {

          this.dateFilter2.start_date2 = e.start;
          this.dateFilter2.end_date2 = e.end;
          filter = {...this.paramsInstruments}

          await this.FETCH_APPLICATION_INSTRUMENT({
            ...this.paramsInstruments,
            start_date: this.dateFilter2.start_date2,
            end_date: this.dateFilter2.end_date2,
          });
          
        }
      } else {
        if (this.card) {
          filter = {...this.paramsMaterial}

          await this.FETCH_APPLICATIONS_MATERIAL({...this.paramsMaterial});
        } else {
          filter = {...this.paramsInstruments}

          await this.FETCH_APPLICATION_INSTRUMENT({ ...this.paramsInstruments});
        }
      }

      this.$_addParamsToLocation({ ...filter, ...this.dateFilter, ...this.dateFilter2 })
      this.isLoading = false;
    },
    // ===============  FILTERS_SECTION END ===============









    // ===============  OTHERS_SECTION START ===============
    removeUnusedParams(obj) {
      Object.keys(obj).forEach((key) => {
        if (obj[key] === "") {
          delete obj[key];
        }
      });
      return obj;
    },
    // async onAuthorSearch(value){
    //   if(value){
    //     clearTimeout(this._timerId)
    //     this._timerId = setTimeout( async () => {
    //       await this.FETCH_APPLICATION_AUTHOR({ mini: true, search: value})
    //     }, 500)
    //   }
    // },
    // ===============  OTHERS_SECTION END ===============






  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

#user-table {
  border-collapse: separate;
  border-spacing: 0 1rem;
}

.dark-layout #user-table .tableRowClass {
  background: #19213a;
}

.dark-layout #radio-dark  label{
  color: white !important;
}

.dark-layout .dark {
  background-color: #283046 !important;
}

#user-table .tableRowClass {
  background: white;
  transform: translateY(5px);
  transition: all 0.5s ease-in-out;
  text-align: center;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

  td {
    border-top: 0;
    padding: 20px !important;

    &:first-child {
      border-top-left-radius: 0.5rem;
      border-bottom-left-radius: 0.5rem;
    }

    &:last-child {
      border-top-right-radius: 0.5rem;
      border-bottom-right-radius: 0.5rem;
    }
  }
}

//  кнопка переключения между заявками и инструментами
[dir] .btn-outline-primary:not(:disabled):not(.disabled).active {
  background-color: #5a9cd9 ;
  color: white;
}

#user-table .tableRowClass:hover {
  transform: translateY(0);
}

#user-table .tableHeadClass {
  background: none !important;
  border: none !important;
}

#user-table .tableRowClass:hover {
  .tableTitle {
    color: #7367f0 !important;
  }
}

.tableHeadClass {
  text-align: center;
  padding-left: 0 !important;
}
</style>
